var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RightArrow = exports.LeftArrow = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _Touchable = _interopRequireDefault(require("../Basic/Touchable"));

var _FontelloIcon = _interopRequireDefault(require("../Basic/FontelloIcon"));

var _Basic = require("../../../elements/Basic");

var _Pagination = _interopRequireDefault(require("../Pagination"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Slider/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var LeftArrow = function LeftArrow(props) {
  return _react.default.createElement(_Touchable.default, {
    display: ['none', 'flex'],
    style: {
      position: 'absolute'
    },
    left: 0,
    height: 40,
    width: 40,
    top: props.itemWidth / 2,
    bg: "black",
    onPress: function onPress() {
      return props.onPress();
    },
    rotate: 180,
    isFlex: true,
    center: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8,
      columnNumber: 5
    }
  }, _react.default.createElement(_FontelloIcon.default, {
    name: "arrow-front",
    color: "white",
    size: "custom",
    fontSize: "28px",
    lineHeight: "28px",
    pl: 1,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 9
    }
  }));
};

exports.LeftArrow = LeftArrow;

var RightArrow = function RightArrow(props) {
  return _react.default.createElement(_Touchable.default, {
    display: ['none', 'flex'],
    style: {
      position: 'absolute'
    },
    right: 0,
    height: 40,
    width: 40,
    top: props.itemWidth / 2,
    bg: "black",
    onPress: function onPress() {
      return props.onPress();
    },
    isFlex: true,
    center: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 5
    }
  }, _react.default.createElement(_FontelloIcon.default, {
    name: "arrow-front",
    color: "white",
    size: "custom",
    fontSize: "28px",
    lineHeight: "28px",
    pl: 1,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 9
    }
  }));
};

exports.RightArrow = RightArrow;

var Slider = function (_React$Component) {
  (0, _inherits2.default)(Slider, _React$Component);

  var _super = _createSuper(Slider);

  function Slider(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Slider);
    _this = _super.call(this, props);

    _this.touchStartHandler = function (event) {
      if (event) {
        var touch = event.changedTouches[0];
        _this.touchInAction = {
          pageX: touch.pageX,
          pageY: touch.pageY
        };
      }
    };

    _this.touchEndHandler = function (event) {
      if (event) {
        var touch = event.changedTouches[0];
        var dx = touch.pageX - _this.touchInAction.pageX;
        var dy = touch.pageY - _this.touchInAction.pageY;

        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 75 && Math.abs(dy) < 50) {
          if (dx < 0) {
            _this.goToNextSlide();
          } else {
            _this.goToPrevSlide();
          }
        }
      }
    };

    _this.goToPrevSlide = function () {
      var currentIndex, translateValue;
      if (_this.state.currentIndex === 0 && !_this.props.enableLoop) return;

      if (_this.state.currentIndex === 0) {
        currentIndex = _this.props.content.length - 1;
        translateValue = -(_this.props.itemWidth * (_this.props.content.length - 1));
      } else {
        currentIndex = --_this.state.currentIndex;
        translateValue = _this.state.translateValue + _this.props.itemWidth;
      }

      _this.setState({
        currentIndex: currentIndex,
        translateValue: translateValue
      });

      if (typeof _this.props.indexUpdate === 'function') _this.props.indexUpdate(currentIndex);
    };

    _this.goToNextSlide = function () {
      var currentIndex, translateValue;

      if (_this.state.currentIndex === _this.props.content.length - 1 && !_this.props.enableLoop) {
        return;
      }

      if (_this.state.currentIndex === _this.props.content.length - 1) {
        currentIndex = 0;
        translateValue = 0;
      } else {
        currentIndex = ++_this.state.currentIndex;
        translateValue = _this.state.translateValue - _this.props.itemWidth;
      }

      _this.setState({
        currentIndex: currentIndex,
        translateValue: translateValue
      });

      if (typeof _this.props.indexUpdate === 'function') _this.props.indexUpdate(currentIndex);
    };

    _this.state = {
      currentIndex: _this.props.startIndex || 0,
      translateValue: 0
    };
    _this.touchInAction = {};
    return _this;
  }

  (0, _createClass2.default)(Slider, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          sliderWidth = _this$props.sliderWidth,
          itemWidth = _this$props.itemWidth,
          content = _this$props.content,
          renderItem = _this$props.renderItem,
          isMobile = _this$props.isMobile,
          showPagination = _this$props.showPagination,
          showCounter = _this$props.showCounter;
      if (!content) return null;
      return _react.default.createElement(_Basic.Column, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 150,
          columnNumber: 13
        }
      }, _react.default.createElement(_Touchable.default, {
        style: {
          position: 'relative'
        },
        width: sliderWidth,
        overflow: "hidden",
        onTouchStart: isMobile ? function (event) {
          return _this2.touchStartHandler(event);
        } : undefined,
        onTouchEnd: isMobile ? function (event) {
          return _this2.touchEndHandler(event);
        } : undefined,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 151,
          columnNumber: 17
        }
      }, _react.default.createElement(_Basic.Row, {
        style: {
          width: itemWidth * this.props.content.length,
          transform: "translateX(" + this.state.translateValue + "px)",
          transition: 'transform ease-out 0.45s'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 166,
          columnNumber: 21
        }
      }, content.map(function (item, index) {
        return renderItem(item, index, _this2.state.currentIndex, _this2.props.content.length, itemWidth);
      })), content.length > 1 && _react.default.createElement(LeftArrow, {
        itemWidth: itemWidth,
        onPress: function onPress() {
          return _this2.goToPrevSlide();
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 184,
          columnNumber: 25
        }
      }), content.length > 1 && _react.default.createElement(RightArrow, {
        itemWidth: itemWidth,
        onPress: function onPress() {
          return _this2.goToNextSlide();
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 190,
          columnNumber: 25
        }
      }), showCounter && _react.default.createElement(_Basic.View, {
        bg: "rgba(0, 0, 0, 0.6)",
        style: {
          position: 'absolute'
        },
        right: 10,
        top: itemWidth - 42,
        py: 1,
        px: 2,
        flexing: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 196,
          columnNumber: 25
        }
      }, _react.default.createElement(_Basic.Text, {
        color: "white",
        size: "medium",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 205,
          columnNumber: 29
        }
      }, this.state.currentIndex + 1 + "/" + this.props.content.length))), showPagination && _react.default.createElement(_Pagination.default, {
        my: 2,
        itemCount: this.props.content.length,
        maxDotCount: 5,
        startIndex: this.state.currentIndex,
        currentIndex: this.state.currentIndex,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 212,
          columnNumber: 21
        }
      }));
    }
  }]);
  return Slider;
}(_react.default.Component);

var _default = Slider;
exports.default = _default;